import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { InvoicePage as InvoicePageView } from "@/components/InvoicePage";
import { useModules } from "@/auth/ModulesContext";
import { useWhatsAppEnabled } from "@/hooks/useWhatsAppEnabled";
import { useEInvoicingRegistered } from "@/hooks/useEInvoicingRegistered";
import { useArAccountingConnected } from "@/hooks/useAccountingConnected";
import { BooksDocumentCard } from "@/books/BooksDocumentCard";

const HUB_BASE_URL = process.env.API_BASE_URL ?? "";

export function InvoicePage() {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { hasModule, holdsModule, modules } = useModules();
  // Resolved entitlement: hasModule is optimistic while loading, which would fire a 403ing delivery read
  // and its "not included in your plan" toast on every invoice.
  const eInvoicingEnabled = modules !== null && hasModule("ar.e_invoicing");
  const eInvoicingRegistered = useEInvoicingRegistered(eInvoicingEnabled);
  const accountingEnabled = useArAccountingConnected(modules !== null && hasModule("ar.accounting"));

  const whatsAppEnabled = useWhatsAppEnabled();

  if (!invoiceId) return null;

  return (
    <InvoicePageView
      invoiceId={invoiceId}
      eInvoicingEnabled={eInvoicingEnabled}
      eInvoicingRegistered={eInvoicingRegistered}
      onBack={() => navigate("/invoices")}
      onDeleted={() => navigate("/invoices")}
      onEditInvoice={(id) => navigate(`/invoices/${id}/edit`)}
      onCustomerClick={(id) => navigate(`/customers/${id}`)}
      onProductClick={(id) => navigate(`/products/${id}`)}
      onCreditNoteClick={(id) => navigate(`/credit-notes/${id}`)}
      onEInvoicingSettingsClick={() => navigate("/organisation/settings/e-invoicing")}
      hubBaseUrl={HUB_BASE_URL}
      accountingEnabled={accountingEnabled}
      booksCard={holdsModule("books") ? <BooksDocumentCard sourceType="Invoice" sourceId={invoiceId} /> : null}
      whatsAppEnabled={whatsAppEnabled}
      autoOpenSendModal={searchParams.get("send") === "1"}
      onSendModalAutoOpened={() => {
        const next = new URLSearchParams(searchParams);
        next.delete("send");
        setSearchParams(next, { replace: true });
      }}
    />
  );
}
